import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { useState, useRef, useEffect } from "react";

const AddressAutocomplete = ({ address, setAddress, options, placeholder }) => {
    const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
    const inputRef = useRef(null);
    const places = useMapsLibrary('places');

    useEffect(() => {
      if (!places || !inputRef.current) return;
  
      const autoCompleteOptions = options ? options : {
        fields: ['geometry', 'name', 'formatted_address', 'address_components'],
        types: ['establishment']
      };
      autoCompleteOptions.componentRestrictions = {country: 'us'}
  
      setPlaceAutocomplete(new places.Autocomplete(inputRef.current, autoCompleteOptions));
    }, [places]);
  
    useEffect(() => {
      if (!placeAutocomplete) return;
  
      placeAutocomplete.addListener('place_changed', () => {
        const place = placeAutocomplete.getPlace()
        console.log(options)
        // if (options) {
        //   if (options.types.length == 1 && options.types[0] == 'address') {
        //     setAddress(place.formatted_address)
        //   }
        //   if ('neighborhood' in options.types) {

        //     setAddress()
        //   }
        // }
        //  {
        //   setAddress(`${place.address_components[0].short_name}, ${place.address_components[2].long_name}`)
        // }
         
        // else {
          setAddress(place.formatted_address)
        // }
        console.log(placeAutocomplete.getPlace())
      });
    }, [setAddress, placeAutocomplete]);
  
    return (
        <div className="autocomplete-container">
            <input className="form-input" placeholder={placeholder} value={address ? address : ""} ref={inputRef} onChange={e => setAddress(e.target.value)}/>
        </div>
    );
  };

export default AddressAutocomplete